import { AxiosError } from 'axios';
import { api, API_BASE_URL } from '@shared/api';
import { attributionSearch } from '@shared/lib/attribution';
import type { User } from '@shared/types';

// Google-вход убран 2026-08-19 (бэк принимает только 'yandex').
export type OAuthProvider = 'yandex';

export class OAuthError extends Error {
  constructor(
    public code:
      | 'NO_REFRESH_TOKEN'
      | 'NETWORK'
      | 'OAUTH_PROVIDER_ERROR'
      | 'OAUTH_MISSING_PARAMS'
      | 'INVALID_OAUTH_STATE'
      | 'OAUTH_PROVIDER_MISMATCH'
      | 'OAUTH_LOGIN_FAILED'
      | 'OAUTH_REFRESH_FAILED'
      | 'UNKNOWN',
  ) {
    super(code);
    this.name = 'OAuthError';
  }
}

export interface OAuthSession {
  user: User;
  accessToken: string;
}

const idFromAccessToken = (token: string): string => {
  try {
    const [, payload] = token.split('.');
    if (!payload) return '';
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return typeof decoded.sub === 'string' ? decoded.sub : '';
  } catch {
    return '';
  }
};

interface RefreshResponse {
  access_token: string;
  token_type: string;
}

export async function completeOAuthLogin(): Promise<OAuthSession> {
  try {
    const { data } = await api.post<RefreshResponse>('/auth/refresh');
    const accessToken = data.access_token;
    return {
      accessToken,
      user: {
        id: idFromAccessToken(accessToken),
        name: '',
        email: '',
        initials: '·',
        emailVerified: true,
      },
    };
  } catch (err) {
    if (err instanceof AxiosError) {
      const status = err.response?.status;
      if (status === 401) throw new OAuthError('NO_REFRESH_TOKEN');
      if (!err.response) throw new OAuthError('NETWORK');
    }
    throw new OAuthError('OAUTH_REFRESH_FAILED');
  }
}

/** Адрес входа через провайдера; метки визита — в query (B), как у SocialButtons. */
export function buildOAuthLoginUrl(provider: OAuthProvider): string {
  return `${API_BASE_URL}/auth/oauth/${provider}/login${attributionSearch()}`;
}
